import { render, staticRenderFns } from "./registerPhyDetailDialog.vue?vue&type=template&id=0809ef0b&scoped=true"
import script from "./registerPhyDetailDialog.vue?vue&type=script&lang=js"
export * from "./registerPhyDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./registerPhyDetailDialog.vue?vue&type=style&index=0&id=0809ef0b&prod&lang=less"
import style1 from "./registerPhyDetailDialog.vue?vue&type=style&index=1&id=0809ef0b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0809ef0b",
  null
  
)

export default component.exports